import React from 'react';
import PropTypes from 'prop-types';
import popup from '../../../popup';
import _ from 'lodash';
import './style.scss';
import '~/assets/css/fitness-globals.scss';
import { LoadingIcon } from '~/assets/svg';
import {getSubscriptionPlans} from "~/redux/user/subscription";
import Background from './Rectangle.png';
import { pushViewPlansEvent, pushSelectPlanEvent } from '~/services/analyticsService';

class ChooseAPlan extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			plans: [],
			loading: false
		}
	}

	componentDidMount(){
		getSubscriptionPlans().then( (plans) => {
			//Only display 2 plans max
			if(plans.length > 2){
				plans = plans.slice(0,2);
			}
			this.setState({...this.state, plans: plans, loading: false});
			pushViewPlansEvent(plans);
		});
		this.setState({loading: true});
	}

	handleSubscriptionClick(plan) {
		pushSelectPlanEvent(plan);
		this.props.onClose();
		popup.fitnessCheckout({
			showCloseButton: false,
			selectedPlan: plan
		});
	}

	//Hack to handle using modal on /viewplans
	handleClose() {
		if(window.location.pathname === '/viewplans'){
			window.location.href = "/home";
		}
		this.props.onClose();
	}

	renderPlan(plan) {
		//Hard coding this for now
		if(plan.renewalCycleType === "YEAR"){
			return (
				<div className="plan" key={plan.id}>
					<h3>ANNUAL <span className="red">SAVE 16%</span></h3>
					<div className="price">{Math.floor(plan.planDetails[0].recurringPaymentAmount)}<span className="cents">99</span></div>
					<p className="trial-text red">7-DAY FREE TRIAL</p>
					<p className="small-text">THEN BILLED YEARLY</p>
					<button className="primary-button black" onClick={() => this.handleSubscriptionClick(plan)}>LET'S GO</button>
				</div>
			);
		}else if (plan.renewalCycleType === "MONTH"){
			return (
				<div className="plan" key={plan.id}>
					<h3>MONTH TO MONTH</h3>
					<div className="price">{Math.floor(plan.planDetails[0].recurringPaymentAmount)}<span className="cents">99</span></div>
					<p className="trial-text red">7-DAY FREE TRIAL</p>
					<p className="small-text">THEN BILLED MONTHLY</p>
					<button className="primary-button black" onClick={() => this.handleSubscriptionClick(plan)}>LET'S GO</button>
				</div>
			);
		}
	}

	render() {
		return (
			<div className="choose-plan fitness-modal" style={{backgroundImage: `url(${Background})`}}>
				<div className="close-button" onClick={this.handleClose.bind(this)}><i className="ion-ios-close-empty"/></div>
				<img className="logo-image" src={ _.get(window.settings, 'images.desktopLogo') } alt="Logo" />
				{!this.state.loading ? <div>
					<p className="subheader">ALL ACCESS. ANYTIME, ANY DEVICE.</p>
					<h2>Join now to lock-in <br/> our introductory price!</h2>
					<div className="offer-container">
						{this.state.plans.map( plan => this.renderPlan(plan))}
					</div>
					{/* <p className="offer-end">Introductory Pricing Ends May 1st!</p> */}
					{this.state.plans.length >= 2 && <p className="legal-text">This subscription automatically renews for ${this.state.plans[1].planDetails[0].recurringPaymentAmount} per month, or annually at ${this.state.plans[0].planDetails[0].recurringPaymentAmount} after the 7-day free trial. You can cancel anytime. By signing up for a free trial, you agree to NEOU's <a href="/tos">Terms of Service</a>.</p>}
		  		</div> : <LoadingIcon />}
		  	</div>
		)
	}


}

ChooseAPlan.propTypes = {
  onClose: PropTypes.func
};

export default ChooseAPlan;